export default {
  '95%-of-cases': '95% of cases<br>end up with<br>the payment of compensation.',
  'add-passenger': 'Add a passenger',
  'agreement-for': 'Agreement form {name}',
  back: 'Back',
  birthdate: 'Birthdate',
  'check-if-you-are-entitled':
    'Check if you are entitled<br> to a compensation',
  'check-your-compensation': 'Check your compensation',
  congratulations: 'Congratulations!',
  'choose-date': 'Choose date',
  'choose-date-from': 'Choose date from',
  'choose-date-to': 'Choose date to',
  'choose-from-the-list': 'Choose from the list',
  'choose-option': 'Choose option',
  clear: 'Clear',
  'congratulations-you-entitled':
    'Congratulations, you are entitled to compensation of up to {compensation} Euro',
  'contact-data': 'Contact data',
  continue: 'Continue',
  'co-passenger': 'Co-passenger',
  'delete-passenger': 'Delete passenger',
  'departure-date': 'Departure date',
  'departed-from': 'Departed from',
  'dont-have-pesel': 'I do not have a PESEL number',
  'e-mail-address': 'E-mail address',
  'enter-your-pesel':
    'Enter your PESEL number and submit a signature confirming the debt transfer agreement for matter number {number}',
  'final-destination': 'Final destination',
  finalization: 'Finalization',
  'find-us-on': 'Find<br>us on:',
  'flight-details': 'Flight details',
  'flight-information': 'Flight information',
  'flight-verification': 'Flight verification',
  finalize: 'Finalize!',
  finish: 'Finalize',
  'first-last-name': 'Name',
  'get-acquainted-with': 'Get acquainted with the contract',
  here: 'available here',
  hours: 'Hours',
  'how-did-you-find-us': 'How did you find us?',
  'how-long-was-your-delay': 'How long was your delay at the destination port?',
  'i-accept-the-conditions': 'I accept the conditions',
  'i-accept-the-privacy-policy': 'I accept the privacy policy',
  'i-did-not-reach-the-destination': 'I did not reach the destination',
  'i-hereby-confirm':
    'I, {name}, hereby confirm the conclusion of the Transfer of Debts Agreement with Passenger Rights sp. O.o. with headquarters in Warsaw, number {number}.',
  'in-order-to-complete':
    'In order to complete the application, please enter the PESEL number and place a signature using the cursor or finger on the screen',
  'intermediate-airport-only-connecting-flights':
    'Intermediate airport (only for connecting flights)',
  'invite-co-passengers': 'Invite co-passengers<br>to claim compensation',
  'legal-guardian': 'Legal guardian',
  'make-an-electric-signature':
    'Make an electronic signature for {name} {surname}',
  minor: 'Minor',
  minutes: 'Minutes',
  'name-of-the-airline': 'Name of the airline',
  'no-results': 'No results',
  none: 'None',
  'number-interrupted-flight': 'Number of the interrupted flight',
  passenger: 'Passenger: {name}',
  'passengers-support': 'Passengers<br>Support<br>Department',
  'pesel-number': 'PESEL number',
  'phone-number': 'Phone number',
  description: 'Description',
  'privacy-policy': 'Privacy Policy',
  project: 'Project',
  'read-about-us': 'Read about us:',
  'ready-accept-the-conditions':
    'Ready!<br>Accept the conditions<br>and finalize the application',
  regulations: 'Regulations',
  'report-another-case': 'Report another case',
  'remember-passengers-know':
    'Remember, let passengers know about their rights!',
  reset: 'Reset',
  'select-the-source': 'Select the source of information',
  sign: 'Sign',
  'signature-of-the-traveler': 'Signature of the traveler',
  'start-typing-to-search-airport': 'Start typing to search for an airport',
  'start-typing-to-search-airline': 'Start typing to search for an airline',
  'thank-you-for-your-thrust':
    'Thank you for your trust<br>in Passenger Rights Sp. z o.o',
  'we-will-inform':
    'We will inform you by phone or email about the start of the case or the need to complete the data.',
  'what-happened-with-the-flight': 'What happened with the flight?',
  'what-was-the-reason':
    'What was the reason for delay provided by the airline?',
  'you-are-under':
    'You are under<br>the constant care<br>of experienced employees.',
  'you-have-a-problem': 'You have a problem? We will help you!',
  'your-application-has-been-submitted':
    'Your application has been submitted for verification by our legal department.',
  'your-contract-is-below': 'Your contract is below',
  'your-risk-nothing':
    'You risk nothing,<br>fill out a form and we<br>will take care of the rest',
  'your-route': 'Your route',
  'error-required': 'This field is required',
  'error-to-short-for-compensation':
    'The time entered is too short to get compensation',
  'error-delay-is-required':
    'Entering delay or checking option "I did not reach the destination" is required',
  'error-delay-exclusive':
    'Entered delay and option "I did not reach the destination" are mutually exclusive',
  'error-dont-qualify':
    'Unfortunately, the reason given by the airline does not qualify for compensation',
  'error-intermediate-airport':
    'Intermediate airport can not be the same as departure',
  'error-destination-overlap':
    'The final destination and other airports can not be the same',
  'error-invalid-email': 'Incorrect e-mail address',
  'COMMON.ADD': 'Add',
  'SIGN.AGREEMENT.AGREEMENT_FORM.CONSENT':
    'I, {passengerName}, hereby confirm the conclusion of the Transfer of Claims Agreement with Passenger Rights sp. z o.o., with its headquarters in Warsaw, number {caseIdent}.',
  'SIGN.AGREEMENT.AGREEMENT_FORM.CONSENT_UNDERAGE':
    'I, {legalGuardian}, acting for and on behalf of the child {passengerName}, hereby confirm the conclusion of the Transfer of Claims Agreement with Passenger Rights sp. z o.o., with its headquarters in Warsaw, number {caseIdent}.',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN': 'Legal guardian',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN_PLACEHOLDER':
    'first and last name of the legal guardian',
  'SIGN.AGREEMENT.AGREEMENT_FORM.LEGAL_GUARDIAN_SIGNATURE':
    'Signature of legal guardian',
  'SIGN.AGREEMENT.AGREEMENT_FORM.NO_PESEL': 'I do not have a PESEL number',
  'SIGN.AGREEMENT.AGREEMENT_FORM.PESEL_ERROR': 'Incorrect PESEL number',
  'SIGN.AGREEMENT.AGREEMENT_FORM.PESEL_NUMBER': 'PESEL number',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TITLE':
    'Enter your PESEL number and submit a signature confirming the transfer of claims agreement for case number',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TRAVLER': 'Passenger',
  'SIGN.AGREEMENT.AGREEMENT_FORM.TRAVLER_SIGNATURE': "Passenger's signature",
  'SIGN.AGREEMENT.AGREEMENT_SETUP.LOADING_CASE': 'Loading application',
  'SIGN.AGREEMENT.CASE_FORM.ADD_DOCUMENTS_TITLE':
    'Add necessary documents for the {passengerName} application',
  'SIGN.AGREEMENT.CASE_FORM.TICKET_POPUP':
    'If you took part in an organized trip, attach boarding pass and contract with travel agency.',
  'SIGN.AGREEMENT.CASE_FORM.TICKET_SCAN': 'Ticket scan',
  'SIGN.AGREEMENT.SIGNED.AGREEMENT_FOR': 'Agreement for {passengerName}',
  'SIGN.AGREEMENT.SIGNED.READY_DESCRIPTION':
    'We are ready to begin the process of obtaining compensation.\nBelow you can download the documents regarding your case.',
  'SIGN.AGREEMENT.SIGNED.TITLE':
    'Thank you for completing the data and confirming the transfer of claims agreement',
  'SIGN.SHARED.CONGRATULATIONS.CASE_NOT_FOUND':
    'We did not find your application',
  'SIGN.SHARED.CONGRATULATIONS.CONTACT_US':
    'If you think something went wrong with your application, please contact us!',
  'SIGN.SHARED.CONGRATULATIONS.NOTIFY':
    'We will inform you by phone or email about the start of the case or the need to complete the data.',
  'SIGN.SHARED.CONGRATULATIONS.VERIFICATION':
    'Your application has been submitted for verification by our legal department.',
  'login-title': 'Sign in',
  'login-button': 'Log in',
  login: 'Login',
  password: 'Password',
  'error-login-or-pass': 'Incorrect login or password',
  'add-flight': 'Add flight',
  filter: 'Filtering',
  'filter-button': 'Filter',
  'flight-number': 'Flight number',
  'flights-list': 'Flights list',
  'add-request': 'Add request',
  'how-long-was-delay': 'How long was your delay?',
  'planned-arrival': 'Scheduled arrival time',
  'actual-arrival': 'Actual arrival time',
  'entitled-amount': 'Compensation',
  'save-flight': 'Save flight',
  'add-new-request': 'Dodaj nowe zgłoszenie',
  'departure-airport': 'Departure airport',
  'destination-airport': 'Destination airport',
  'prefferred-date-of-first-contact': 'Preferred date of first contact',
  comments: 'Comments',
  'add-comments': 'Add comments',
  'add-first-name': 'Add first name',
  'add-last-name': 'Add last name',
  'add-e-mail-address': 'Add e-mail',
  'add-description': 'Add description',
  deadline: 'Deadline',
  'potential-cases': 'Potential cases',
  'add-potential-cases': 'Add potential cases',
  'first-name': 'First name',
  'last-name': 'Last name',
  'requests-history': 'Requests history',
  'filters-invalid-search':
    'The flight number should be longer than 4 characters'
}
